import React from 'react'
import Link from 'next/link'

const Banner = () => {
  return (
    <div className="bg-gradient-to-r from-pink-50 via-white to-pink-50 border-b border-pink-100 text-gray-900 py-2 px-4 text-center relative z-50">
      <Link href="/pricing">
        <a className="font-heading font-medium text-sm sm:text-base hover:text-pink-700 transition-colors flex items-center justify-center gap-2">
          <span className="font-bold text-pink-600">Black Friday Deal:</span>
          <span>Get Lifetime Access for $149</span>
          <span className="hidden sm:inline text-gray-500">-</span>
          <span className="text-gray-500 text-xs sm:text-sm">Save 60% today</span>
        </a>
      </Link>
    </div>
  )
}

export default Banner
